/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Reason_RetiredInputs */

const fr_vehicle_action_archive_reason_retired = /** @type {(inputs: Vehicle_Action_Archive_Reason_RetiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réforme`)
};

const en_vehicle_action_archive_reason_retired = /** @type {(inputs: Vehicle_Action_Archive_Reason_RetiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retired`)
};

/**
* | output |
* | --- |
* | "Retired" |
*
* @param {Vehicle_Action_Archive_Reason_RetiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_reason_retired = /** @type {((inputs?: Vehicle_Action_Archive_Reason_RetiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Reason_RetiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_reason_retired(inputs)
	return en_vehicle_action_archive_reason_retired(inputs)
});